<template>
    <div class="Product">
        <pubHeader></pubHeader>
        <productBanner></productBanner>
        <div class="maxmain">
            <div class="productCenter">
                <dl v-for="(item,index) in list" :key="index">
                    <dt>
                        <img :src="item.images" alt="">
                    </dt>
                    <dd>
                        <h1>{{item.name}}</h1>
                        <p>{{item.detail}}</p>
                        <ul>
                            <li v-for="(val,ind) in item.data" :key="ind">
                                <span>{{val.name}}</span>
                            </li>
                        </ul>
                    </dd>
                </dl>
            </div>
        </div>
        <pubFooter></pubFooter>
    </div>
</template>
<script>
import pubHeader from "@/components/pubHeader"
import pubFooter from "@/components/pubFooter"
import productBanner from "./productBanner"
export default {
    name: "Product",
    components: {pubHeader,productBanner,pubFooter},
    data(){
        return{
            list:[
                {
                    name: "医生端",
                    detail:"预约管理 ，诊疗数据分析，常用处方管理，服务设置",
                    data:[
                        {
                            name: "AI医助",
                        },
                        {
                            name: "在线开方",
                        },
                        {
                            name: "智能随诊",
                        }
                    ]
                }
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
.Product{
    width: 100%;
    min-width: 1024px;
    overflow: hidden;
    @media screen and (max-width: 991px){ 
        .pubFooter{
            width: 100%;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }
    .productCenter{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        dl{
            width: 60.25%;
            display: flex;
            padding: 40px 0 0 0;
            justify-content: space-between;
            dt{
                flex: 2.5;
                img{
                    width: 100%;
                }
            }
            dd{
                flex: 7.5;
                display: flex;
                flex-direction: column;
                align-items: center;
                h1{
                    font-size: 20px;
                    color: #333333;
                    text-align: center;
                }
                p{
                    font-size: 12px;
                    color: #999999;
                    text-align: center;
                    padding: 10px 0 40px 0;
                }
                ul{
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    li{
                        width: 30%;
                        display: inline-block;
                        text-align: center;
                        font-size: 14px;
                        img{
                            width: 90px;
                            height: 90px;
                            display: inline-block;
                        }
                        span{
                            width: 100%;
                            display: inline-block;
                            font-size: 14px;
                            color: #333333;
                            padding: 10px 0 0 0;
                        }
                    }
                }
            }
        }
        dl:nth-of-type(2){
            flex-direction: row-reverse;
            ul{
                justify-content: flex-start;
            }
        }
        dl:nth-last-of-type(1){
            padding-bottom: 40px;
        }
    }
    
}
</style>